import React from 'react';

import Edit from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import InvoiceForm from './InvoiceForm';


const InvoiceEdit = (props) => (
	<Edit {...props}>
		<SimpleForm>
			<InvoiceForm />
		</SimpleForm>
	</Edit>
);

export default InvoiceEdit;